import { FunctionComponent } from 'react';
import SVGLoader, { SVGLoaderProps } from './SVGLoader';

const BlurIcon: FunctionComponent<SVGLoaderProps> = ({
  viewboxHeight = '14px',
  viewboxWidth = '14px',
  width = '13px',
  height = '14px',
  ...props
}) => (
  <SVGLoader
    {...props}
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    width={width}
    height={height}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.46 1.418a.855.855 0 1 0-1.21 1.21.855.855 0 0 0 1.21-1.21ZM2.174 4.704a.855.855 0 1 0-1.21 1.21.855.855 0 0 0 1.21-1.21Zm0 4.495a.855.855 0 1 1-1.21-1.21.855.855 0 0 1 1.21 1.21Zm9.857-3.286a.855.855 0 1 1-1.209-1.209.855.855 0 0 1 1.21 1.21Zm0 3.286a.855.855 0 1 1-1.209-1.21.855.855 0 0 1 1.21 1.21Zm-7.78 2.077a.855.855 0 1 0 1.208 1.209.855.855 0 0 0-1.208-1.21Zm3.285 0a.855.855 0 1 0 1.209 1.209.855.855 0 0 0-1.209-1.21Zm0-8.648a.855.855 0 1 1 1.21-1.21.855.855 0 0 1-1.21 1.21Zm-3.964 2.68a1.286 1.286 0 1 1 2.571 0 1.286 1.286 0 0 1-2.571 0Zm3.285 0a1.286 1.286 0 1 1 2.572 0 1.286 1.286 0 0 1-2.572 0Zm-2 2a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.571Zm2 1.287a1.286 1.286 0 1 1 2.571 0 1.286 1.286 0 0 1-2.57 0Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5.952h12v12H.5z" />
      </clipPath>
    </defs>
  </SVGLoader>
);

export default BlurIcon;
